<script lang="ts">
import { BURNING_TOPICS } from '$types/burning-topics';

interface Props {
  selected: string[];
  counts?: Record<string, number>;
  onToggle: (id: string) => void;
}

const { selected, counts = {}, onToggle }: Props = $props();
</script>

<div class="chips" role="group" aria-label="Brennende Themen">
  {#each BURNING_TOPICS as t}
    {@const on = selected.includes(t.id)}
    <button
      type="button"
      class={'chip ' + (on ? 'chip-on' : 'chip-off')}
      aria-pressed={on}
      onclick={() => onToggle(t.id)}>
      <span class="chip-mark">{t.emoji}</span>
      <span class="chip-label">{t.label}</span>
      {#if counts[t.id] !== undefined}<span class="chip-count">{counts[t.id]}</span>{/if}
      <span class="chip-kw">KW{t.drillKw}</span>
    </button>
  {/each}
</div>

<style>
  .chips { display: flex; flex-wrap: wrap; gap: 6px; margin: 4px 0 8px; }
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border: 1px solid var(--rule);
    background: var(--paper);
    border-radius: var(--radius-chip);
    font-size: 12px;
    font-family: var(--font-mono);
    white-space: nowrap;
    transition: transform 80ms ease;
    min-height: 32px;
  }
  .chip:hover { transform: translateY(-1px); }
  .chip-mark { color: var(--accent); font-weight: 700; }
  .chip-label { color: var(--ink); font-weight: 500; }
  .chip-count {
    background: var(--paper-3);
    color: var(--ink-2);
    padding: 0 5px;
    font-size: 10px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    border-radius: 999px;
    min-width: 18px;
    text-align: center;
  }
  .chip-kw { font-size: 9px; color: var(--muted); letter-spacing: 0.08em; }
  .chip-on {
    background: var(--ink);
    border-color: var(--ink);
    color: var(--paper);
  }
  .chip-on .chip-label { color: var(--paper); }
  .chip-on .chip-count { background: var(--accent); color: #fff; }
  .chip-on .chip-kw { color: var(--paper-3); }
  .chip-on .chip-mark { color: var(--accent); }
</style>
